import { useEffect } from "react";
import { CONTENT, LANGS, pathFor, usePage } from "@/lib/i18n";

export const SITE_ORIGIN = "https://homeinslovenia.org";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const faqJsonLd = (lang) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  inLanguage: lang,
  mainEntity: CONTENT[lang].faq.items.map((it) => ({
    "@type": "Question",
    name: it.q,
    acceptedAnswer: { "@type": "Answer", text: it.a },
  })),
});

export const Seo = () => {
  const { lang, page } = usePage();
  useEffect(() => {
    const m = CONTENT[lang].meta[page] || CONTENT[lang].meta.home;
    const url = SITE_ORIGIN + pathFor(lang, page === "notfound" ? "home" : page);
    document.title = m.title;
    document.documentElement.lang = lang;
    setMeta("name", "description", m.desc);
    setMeta("property", "og:title", m.title);
    setMeta("property", "og:description", m.desc);
    setMeta("property", "og:url", url);
    setMeta("property", "og:locale", lang === "tr" ? "tr_TR" : "sl_SI");
    setMeta("name", "twitter:title", m.title);
    setMeta("name", "twitter:description", m.desc);
    document.head.querySelectorAll("[data-seo]").forEach((l) => l.remove());
    if (page === "notfound") {
      setMeta("name", "robots", "noindex");
      return;
    }
    setMeta("name", "robots", page === "thanks" ? "noindex" : "index, follow, max-image-preview:large");
    const add = (rel, href, hreflang) => {
      const l = document.createElement("link");
      l.rel = rel;
      l.href = href;
      if (hreflang) l.hreflang = hreflang;
      l.setAttribute("data-seo", "1");
      document.head.appendChild(l);
    };
    add("canonical", url);
    LANGS.forEach((l) => add("alternate", SITE_ORIGIN + pathFor(l, page), l));
    add("alternate", SITE_ORIGIN + pathFor("tr", page), "x-default");
    if (page === "home") {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo", "1");
      s.textContent = JSON.stringify(faqJsonLd(lang));
      document.head.appendChild(s);
    }
  }, [lang, page]);
  return null;
};
